import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
// import { FormGroup, FormControl, Validators } from '@angular/forms';
import { PageBaseComponent } from './page-base.component';
import { AuthService } from '@app/core/services';
import { environment } from '@environments/environment';
import { User } from '@app/core/models';


@Component({
  selector: 'login',
  styleUrls: ['./styles/styles-wrapper.css', './styles/styles-form.css'],
  styles: [`
    h1 {
      text-align: center;
    }
    .avatar {
      display: flex;
      align-items: center;
      flex-direction: column;
      margin-bottom: 30px;
      margin-top: 48px;
    }
    .k-avatar-solid.k-avatar-primary {
      background-color: transparent;
      border-color: transparent;
    }
    .alert {
      background-color: #cf1b0a;
      padding: 12px 26px;
      border-radius: 24px;
      text-align: center;
      color: white;
      margin-top: 20px;
    }
    .wrapper-route {
      margin-bottom: 120px;
    }
    .field {
      color: #a0a0a0;
      padding-top: 8px;
    }
  `],
  template: `
      
    <div class="wrapper-route">

      <div class="avatar">
        <kendo-avatar [border]="true" [imageSrc]="defaultImage" width="128px" height="128px"></kendo-avatar>
        <span class="field"><span class="k-icon k-i-globe"></span> Sucursal: {{branchName}}</span>
      </div>

      <h1>Login</h1>

      <div class="k-block" *ngIf="loading">
        <kendo-loader [type]="'pulsing'" [size]="'medium'"></kendo-loader>
      </div> 

      <div *ngIf="error && !loading" class="alert alert-danger mt-3 mb-0">{{error}}</div>

      <form novalidate [formGroup]="form" *ngIf="!isAdmin">
        <div class="example-wrapper form-detail">        
          <div class="row">                                  
            <div class="col-field">
              <kendo-label text="Usuario:"></kendo-label>
              <kendo-textbox-container>
                <kendo-textbox formControlName="username" [clearButton]="true" controlTrim></kendo-textbox>
              </kendo-textbox-container>
              <div *ngIf="f.username.invalid && (f.username.dirty || f.username.touched)">                  
                <div *ngIf="f.username.errors">
                  <kendo-formerror *ngIf="f.username.errors.required">
                    Error: Campo requerido.
                  </kendo-formerror>
                </div>   
              </div>
            </div>
            <div class="col-field">
              <kendo-label text="Contraseña:"></kendo-label>
              <kendo-textbox-container>
                <password-input formControlName="password" controlTrim></password-input>
              </kendo-textbox-container>
              <div *ngIf="f.password.invalid && (f.password.dirty || f.password.touched)">                  
                <div *ngIf="f.password.errors">
                  <kendo-formerror *ngIf="f.password.errors.required">
                    Error: Campo requerido.
                  </kendo-formerror>
                </div>   
              </div>
            </div>                     
          </div>
        </div>
      </form>

      <kendo-floatingactionbutton icon="login" text="Iniciar sesión" themeColor="primary" [offset]="{ x: '12px', y: (error) ? '542px' : '470px' }" [align]="{ horizontal: 'center', vertical: 'top' }" positionMode="absolute" [disabled]='!form.valid && !loading' (click)="onSave()" *ngIf="!loading"></kendo-floatingactionbutton>

    </div>

  `    
})
export class LoginComponent extends PageBaseComponent implements OnInit {
    
  public defaultImage: string = environment.assets.DEFAULT_SERVICE_COLOR;

  public branchName: string = environment.branchName;

  public form: FormGroup = new FormGroup({
      'username': new FormControl("", Validators.required),
      'password': new FormControl("", Validators.required)
  });

  public loading = false;
  // public submitted = false;

  public returnUrl: string;

  public error = '';

  
  constructor(public authService: AuthService, protected router: Router, protected route: ActivatedRoute) { 

    super(authService, router)
    console.log('LoginComponent');

  }

  protected getFormGroup(): FormGroup {

    return new FormGroup({            
      'username': new FormControl("", Validators.required),
      'password': new FormControl("", Validators.required)
    });

  };

  ngOnInit() {

    this.form = this.getFormGroup();

    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
  }

  // convenience getter for easy access to form fields
  get f() { return this.form.controls; }

  protected reset() {

    this.loading = false;
    this.error = '';
    this.form.patchValue({
        password: ''
    });
  
  }
  
  onSave() {
      
    this.loading = true;
    this.authService.login(this.f.username.value, this.f.password.value)
      // .pipe(this.res.data)
      .subscribe(
        user => {
          if(user) {
            this.currentUser = user;
            this.reset();
            this.router.navigate([this.returnUrl]); 
          }
          else {
            this.error = 'No existe el usuario ó la contraseña es incorrecta.';
            this.loading = false;
          }
        },
        error => {
          this.error = error;
          this.loading = false;
        }
          // (res) => {
          // // super.next(x)
          // console.log(res);              
          // // if(callback)
          // //     callback(table, res);
          // // },
          // // (fail) => {        
          // // console.log("Error", fail);
          // // this.alertService.showError(fail.error.detail.sql + ' ' + fail.error.detail.sqlMessage);
          // }
      ); 
      // .pipe(first())
      // .subscribe(
      //     data => {
      //         this.router.navigate([this.returnUrl]);
      //     },
      //     error => {
      //         this.error = error;
      //         this.loading = false;
      //     });
  }

}